import { TextField, Typography } from '@mui/material';
import useAppStore from 'store/useAppStore';
import { memo } from 'react';

const IndexField = memo(({ type, valueKey, index, ...textFieldProps }) => {
  const readOnly = useAppStore((state) => state.selectedProject.readOnly);
  const value = useAppStore((state) => state[type][index][valueKey]);
  const setter = useAppStore((state) => state.setter);
  const handleInputChange = (index, value) => {
    setter(type, (draft) => {
      draft[index][valueKey] = value;
    });
  };
  if (readOnly) {
    return <Typography>{value}</Typography>;
  }
  return (
    <TextField
      {...textFieldProps}
      fullWidth
      value={value}
      onChange={(event) => {
        handleInputChange(index, event.target.value);
      }}
    />
  );
});
IndexField.displayName = 'IndexField';
export default IndexField;
